import { isIOS, isMacOs } from 'react-device-detect';

export type AnimationPlatform = 'apple' | 'joypixel';

// кешируем ось
let cachedPlatform: AnimationPlatform | null = null;

export const getAnimationPlatform = (): AnimationPlatform => {
    if (!cachedPlatform) {
        cachedPlatform = isIOS || isMacOs ? 'apple' : 'joypixel';
        console.log(`[Platform Detection] Using ${cachedPlatform} animations`);
    }
    return cachedPlatform;
};
